export const contextEN = {
  title: "Treatment overview",
  period: "Overview period",
  days: "Last {{days}} days",
  timezone: "Dates, times and period boundaries use {{timezone}}.",
  countHint: "Unconfirmed doses are unknown, not assumed missed. Actual administrations within this period: {{count}}. These include separate entries and may differ from scheduled-dose confirmations.",
  observations: "Observations recorded in this period: {{count}}",
  plans: "Prescriptions applying in this period",
  noPlans: "No prescription applies in this period.",
  chartHint: "Latest values and graphs use only this period. Large graphs are sampled while retaining extremes; the list below includes every measurement. Connecting lines are not continuous monitoring or a treatment-effect assessment.",
  measurements: "Measurement details",
  measurement: "Measurement",
  measuredAt: "Measured at",
  addMeasurement: "Add measurement",
  latestHint: "Latest reading within the selected period. Dates follow the therapy timezone.",
  value: "Recorded value",
  shown: "Showing {{shown}} of {{total}} measurements",
  empty: "No weight or blood pressure measurements in this period. Choose another period or add a measurement.",
};

export const contextHR: Record<keyof typeof contextEN, string> = {
  title: "Pregled liječenja",
  period: "Razdoblje pregleda",
  days: "Posljednjih {{days}} dana",
  timezone: "Datumi, vremena i granice razdoblja koriste zonu {{timezone}}.",
  countHint: "Za nepotvrđene doze ne pretpostavlja se da su propuštene. Stvarno uzete doze unutar razdoblja: {{count}}. Uključuju i zasebne unose pa se broj može razlikovati od potvrda planiranih doza.",
  observations: "Zapažanja zabilježena u razdoblju: {{count}}",
  plans: "Recepti koji vrijede u ovom razdoblju",
  noPlans: "Nijedan recept ne vrijedi u ovom razdoblju.",
  chartHint: "Posljednje vrijednosti i grafovi obuhvaćaju samo ovo razdoblje. Veliki grafovi prikazuju uzorak uz očuvanje ekstrema; popis ispod uključuje sva mjerenja. Spojnice ne predstavljaju kontinuirano praćenje ni procjenu učinka liječenja.",
  measurements: "Pojedinosti mjerenja",
  measurement: "Mjerenje",
  measuredAt: "Vrijeme mjerenja",
  addMeasurement: "Dodaj mjerenje",
  latestHint: "Posljednje mjerenje unutar odabranog razdoblja. Datumi prate vremensku zonu terapije.",
  value: "Zabilježena vrijednost",
  shown: "Prikazano {{shown}} od {{total}} mjerenja",
  empty: "U ovom razdoblju nema mjerenja težine ili krvnog tlaka. Odaberite drugo razdoblje ili dodajte mjerenje.",
};
